import { requireAuth } from '@/features/auth/guards/require-auth'
import { usersListQuery } from '@/features/references/users/users-query'
import { warehousesListQuery } from '@/features/references/warehouses/queries/warehouse-query'
import { TransferDetailPage } from '@/features/transfers/pages/transfer-detail-page'
import { transferDetailQuery } from '@/features/transfers/queries/transfer-query'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

const paramsSchema = z.object({
  transferId: z.coerce.number().int().positive(),
})

export const Route = createFileRoute('/_app/transfers/$transferId')({
  beforeLoad: requireAuth,
  parseParams: paramsSchema.parse,
  stringifyParams: ({ transferId }) => ({ transferId: String(transferId) }),
  loader: async ({ params, context }) => {
    const qc = context.queryClient
    const [transfer] = await Promise.all([
      qc.ensureQueryData(transferDetailQuery(params.transferId)),
      qc.ensureQueryData(warehousesListQuery()),
      qc.ensureQueryData(usersListQuery()),
    ])
    return { number: transfer.number }
  },
  // Crumb: «<список> › <номер документа>» — the number from the loader, not the id.
  staticData: {
    crumbParent: { label: messages.crumbs.transfers, to: '/transfers/' },
    crumb: (m: { loaderData?: { number: string } }) => m.loaderData?.number ?? '…',
  },
  component: () => {
    const { transferId } = Route.useParams()
    return <TransferDetailPage transferId={transferId} />
  },
})
